import { createSelector } from 'reselect';
import { flow, pipe } from 'fp-ts/function';
import { orderBy } from 'lodash/fp';
import { array } from 'fp-ts';
import { Bill, BillState } from '@mews-commander/data-access';
import { getId } from '@mews/framework';
import { getBillsByAssociatedAccountId, getBillsByOwnerId } from '@mews-commander/legacy-entities/src/ducks/bills';

const isOpen = ({ state }: Bill) => state === BillState.Open;

export const filterOrderMapBills = flow<[Bill[]], Bill[], Bill[], string[]>(
    array.filter(isOpen),
    orderBy<Bill>(['isVirtual', 'createdUtc'], ['desc', 'desc']),
    array.map(getId)
);

export const getOrderedBillsByOwnerIdAndAssociatedId = createSelector(
    getBillsByOwnerId,
    getBillsByAssociatedAccountId,
    (ownedBills, associatedBills) => pipe([...ownedBills, ...associatedBills], filterOrderMapBills)
);

export const getOrderedBillsByOwnerIdAndAssociatedIdCount = createSelector(
    getOrderedBillsByOwnerIdAndAssociatedId,
    (billIds) => billIds.length
);

export const getOrderedOpenBillIdsByOwnerId = flow(getBillsByOwnerId, filterOrderMapBills);
